module.exports = __webpack_public_path__ + "static/stageSet11-2f665bd65802d3f2d9a47537f91119d7.jpg";